import WhatsAppSchedaLeadDialog from "./WhatsAppSchedaLeadDialog";

export default function WhatsAppRichiestaPostiDialog(props) {
  return <WhatsAppSchedaLeadDialog {...props} mode="posti" />;
}
